import React, { useEffect, useState } from 'react';
import { Divider, Typography, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { FormInputCheckbox } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputCheckbox';
import { FormInputDatePicker } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDatePicker';
import { useSelector } from 'react-redux';
import {
  selectIslandsCancel,
  selectPlacementLandsGtgDetails,
} from '../../../../../../../store/redux-store/placement-details/selectors';
import { useFormContext } from 'react-hook-form';
const useStyles = makeStyles()({
  sectionTitle: {
    paddingBottom: '6px',
  },
  inputContainer: {
    paddingTop: '12px !important',
  },
  divider: {
    height: '2px',
    margin: '10px 10px 10px 0px',
    backgroundColor: '#00000014',
  },
  subTitleStyle: {
    fontWeight: 'bold',
  },
});
export const BackgroundCheck = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const selectiscancel = useSelector(selectIslandsCancel);
  const [isCrossReferenced, setIsCrossReferenced] = useState<boolean>(
    selectLandsGtgDetails?.crimCheckDate ? true : false,
  );
  const { getValues, setValue, clearErrors } = useFormContext();
  useEffect(() => {
    setValue('pDateOfValidation', selectLandsGtgDetails?.crimCheckDate);
    setIsCrossReferenced(selectLandsGtgDetails?.crimCheckDate ? true : false);
  }, [selectLandsGtgDetails, selectiscancel, setValue]);

  const handleCrossReferenced = event => {
    setValue('pCrossReferenced', event, { shouldDirty: true });
    setIsCrossReferenced(event);
    if (event === false) {
      clearErrors('pDateOfValidation');
      setValue('pDateOfValidation', null, { shouldDirty: true });
    }
    props.handleFieldChanges?.();
  };
  const handleDateOfValidation = event => {
    setValue('pDateOfValidation', event, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  return (
    <>
      <Box className={classes.sectionTitle}>
        <Typography variant="subtitle1" component="div" className={classes.subTitleStyle}>
          {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.backgroundCheck.title')}
        </Typography>
      </Box>
      <Divider variant="middle" className={classes.divider} />
      <LayoutGrid direction="column" className={classes.inputContainer}>
        <LayoutGridItem data-testid={'cross-referenced'}>
          <FormInputCheckbox
            name="pCrossReferenced"
            isChecked={isCrossReferenced}
            handleChecked={handleCrossReferenced}
            checkboxLabel={t(
              'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.backgroundCheck.crossReferencedAllAliasAllCountiresNeeded',
            )}
            isDisabled={!props.hasEditPermission}
          />
        </LayoutGridItem>
        <LayoutGridItem md={4}>
          <FormInputDatePicker
            name={'pDateOfValidation'}
            label={t(
              'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.backgroundCheck.dateOfValidation',
            )}
            handleChange={handleDateOfValidation}
            require={false}
            readOnly={!props.hasEditPermission || !isCrossReferenced}
            inputValue={getValues('pDateOfValidation')}
            trailingIconVisible={true}
          />
        </LayoutGridItem>
      </LayoutGrid>
    </>
  );
};
